import { createSelector } from '@reduxjs/toolkit';

import { payloadSel } from '@location';
import { urlUserIdSel } from '@shared';
import { packRosterItemsSel } from '@shared/duck/selectors/general.selectors';

export const activityTypeIdSel = state => payloadSel(state).activityType;

export const personInfoSel = createSelector(
  urlUserIdSel,
  packRosterItemsSel,
  (userId, packRoster) => packRoster.find(item => item.userId == userId),
);

export const isPersonWithinUnitSel = createSelector(
  personInfoSel,
  personInfo => !!personInfo,
);
